import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyDZOWq7oKDCSuw73TKWGT9Ms9tmkSS3eFs",
    authDomain: "nevyati-products.firebaseapp.com",
    databaseURL: "https://nevyati-products-default-rtdb.firebaseio.com",
    projectId: "nevyati-products",
    storageBucket: "nevyati-products.firebasestorage.app",
    messagingSenderId: "474907407632",
    appId: "1:474907407632:web:cd6adf986eb46bea4fa195",
    measurementId: "G-TMCWR9E4EE"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);